module.exports = __webpack_public_path__ + "static/img/img-logo-bprs-gaido.4dd8ddf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-logo-bprs-gaido.png
// module id = k+iI
// module chunks = 36